import React from 'react';
import {
    Grid, InputAdornment,
    TextField,
} from '@material-ui/core';
import {useTranslation} from "react-i18next";
import {Link} from "react-feather";


const ConnectorFormFile = ({fileUrl,  setFileUrl, submitted, ...rest }) => {
    const { t } = useTranslation('connector');

    return (    
        <Grid item xs={12}>
            <TextField
                fullWidth
                id="connector-file"
                label={t('label.url')}
                variant="outlined"
                value={ fileUrl }
                onChange={(event) => setFileUrl(event.target.value)}
                required
                InputProps={{
                    startAdornment: <InputAdornment style={{opacity: 0.5}} position="start"><Link /></InputAdornment>,
                }}
                disabled={submitted}
            />
        </Grid>
    )
}

export default ConnectorFormFile;